import React, { forwardRef } from 'react'

import { TextInput } from '../../Input'

const Input = forwardRef(({ ...rest }, ref) => (
  <TextInput ref={ref} className="form-input" {...rest} />
))

export default Input
